// action types
import { createRequestTypes } from "../../utils";

// Fetch Orders
export const FETCH_ORDERS = createRequestTypes("FETCH_ORDERS");

export const fetchOrdersRequest = (filters = {}) =>
    ({ type: FETCH_ORDERS.REQUEST, payload: { filters } });

export const fetchOrdersSuccess = (data) =>
    ({ type: FETCH_ORDERS.SUCCESS, payload: { data } });

export const fetchOrdersFailure = (error) =>
    ({ type: FETCH_ORDERS.FAILURE, payload: error });

// Update Order Status
export const UPDATE_ORDER_STATUS = createRequestTypes("UPDATE_ORDER_STATUS");

export const updateOrderStatusRequest = (orderId, status) =>
    ({ type: UPDATE_ORDER_STATUS.REQUEST, payload: { orderId, status } });

export const updateOrderStatusSuccess = (data) =>
    ({ type: UPDATE_ORDER_STATUS.SUCCESS, payload: { data } });

export const updateOrderStatusFailure = (error) =>
    ({ type: UPDATE_ORDER_STATUS.FAILURE, payload: error });
